<template>
  <div>
    <v-dialog v-model="userCreationDialog">
      <UserEdit :userId="'-1'" @finish="onUserCreated" :super-admin="true" :company-id="userEditCompanyId"/>
    </v-dialog>
    <v-dialog v-model="askDeleteCompany" width="500">
      <v-card v-if="companyForDeletion">
        <v-card-title>
          Wirklich löschen? Billomat: {{ companyForDeletion.billomatId }} | Name: {{ companyForDeletion.name }}
        </v-card-title>
        <v-card-actions>
          <v-btn @click="finallyDeleteCompany()">Endgültig Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-breadcrumbs v-if="!movement" :items="breadCrumbs">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item @click="clickBreadCrumb(item.text)" :disabled="item.disabled" :link="true">
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <div v-if="selectedCompany === null" style="margin: 24px">
      <h2 v-if="!movement">Firmenverwaltung</h2>
      <br v-if="!movement">
      <v-banner v-else color="primary" icon="mdi-help" icon-color="white" dark>Suche die Zielfirma und klicke bei
        Bearbeiten auf "Jetzt bewegen". Abbrechen befindet sich daneben.
      </v-banner>
      <v-data-table :headers="standardHeaders" :items="companies" :search="search" :items-per-page="15"
                    class="elevation-1">
        <template v-slot:top>
          <v-text-field append-icon="mdi-magnify" v-model="search" single-line label="Suche" class="mx-4"/>
        </template>
        <template v-slot:item.woocommerceId="{ item }">
          <v-btn @click="openLink(item.woocommerceId)" class="ma-2" outlined x-small color="indigo">
            {{ item.woocommerceId }}
          </v-btn>
        </template>
        <template v-slot:item.edit="{ item }" v-if="!movement">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="openEdit(item)" class="ma-2" outlined v-bind="attrs" v-on="on" x-small fab color="indigo">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Bearbeiten</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="openCourses(item)" class="ma-2" outlined v-bind="attrs" v-on="on" x-small fab
                     color="indigo">
                <v-icon>mdi-database-settings-outline</v-icon>
              </v-btn>
            </template>
            <span>Paket zuweisen</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="openMembers(item)" class="ma-2" outlined v-bind="attrs" v-on="on" x-small fab
                     color="indigo">
                <v-icon>mdi-account</v-icon>
              </v-btn>
            </template>
            <span>Mitglieder anzeigen</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="createMember(item)" class="ma-2" outlined x-small v-bind="attrs" v-on="on" fab
                     color="indigo">
                <v-icon>mdi-account-plus</v-icon>
              </v-btn>
            </template>
            <span>Nutzer hier anlegen</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="deleteCompany(item)" class="ma-2" outlined x-small v-bind="attrs" v-on="on" fab
                     color="red">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Firma Löschen</span>
          </v-tooltip>
        </template>
        <template v-slot:item.edit="{ item }" v-else>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="startMovement(item)" class="ma-2" outlined x-small fab color="indigo" v-bind="attrs"
                     v-on="on">
                <v-icon>mdi-content-save-move</v-icon>
              </v-btn>
            </template>
            <span>Firma ändern</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="endMovement()" class="ma-2" outlined x-small fab color="indigo" v-bind="attrs" v-on="on">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>Abbruch</span>
          </v-tooltip>

        </template>

      </v-data-table>
    </div>
    <div v-else style="margin: 24px">
      <v-btn @click="selectedCompany = null" class="ma-2" outlined x-small color="indigo">
        Zurück
      </v-btn>
      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab>
          Einstellungen
        </v-tab>
        <v-tab>
          Paketzuweisungen
        </v-tab>
        <v-tab>
          Nutzer
        </v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <CompanyEdit :company-id="selectedCompany.id" @finish="onCompanyCreated" :super-admin="true"/>
          </v-tab-item>
          <v-tab-item>
            <SuperAdminCompanyCourseSettings :company-id="selectedCompany.id" @detail="detailSet"
                                             :detail-license="detail"/>
          </v-tab-item>
          <v-tab-item>
            <v-switch v-if="loading" loading="primary" :input-value="loadInActiveMembers"
                      label="Inklusive inaktiven Nutzern" @change="triggerLoadCompanyUsersWithInactiveChange"/>
            <v-switch v-else :input-value="loadInActiveMembers" label="Inklusive inaktiven Nutzern"
                      @change="triggerLoadCompanyUsersWithInactiveChange"/>
            <MemberList :super-admin="true" :members="members" @reload="loadCompanyUsers"/>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
      <v-btn class="ma-1" color="info" @click="createCompany" v-if="selectedCompany === null">
        Firma anlegen
        <template v-slot:loader>
          <span class="custom-loader">
            <v-icon light>mdi-cached</v-icon>
          </span>
        </template>
      </v-btn>
    </div>
    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top app>Fehler beim Löschen</v-snackbar>
    <v-snackbar :timeout="5000" :value="success" color="success" left shaped top app>Gelöscht</v-snackbar>
  </div>

</template>

<script>

import CompanyEdit from "@/components/CompanyEdit";
import SuperAdminCompanyCourseSettings from "@/components/SuperAdminCompanyCourseSettings";
import Company from "@/models/Company";
import UserEdit from "@/components/UserEdit";
import MemberList from "@/components/MemberList.vue";

export default {
  name: "SuperAdminCompanySettings",
  components: {MemberList, UserEdit, SuperAdminCompanyCourseSettings, CompanyEdit},
  watch: {
    "selectedCompany"() {
      if(this.selectedCompany!==null) {
        this.loadCompanyUsers();
      }
    }
  },
  data: () => ({
    userCreationDialog: false,
    userEditCompanyId: null,
    loadInActiveMembers: false,
    loading: false,
    members: [],
    askDeleteCompany: false,
    detail: null,
    selectedCompany: null,
    companyForDeletion: null,
    error: false,
    success: false,
    companies: [],
    tab: null,
    search: '',
    standardHeaders: [
      {
        text: "Firmenname",
        value: "name",
      },
      {text: "Ort", value: "location"},
      {text: "E-Mail", value: "notificationEmail"},
      {text: "Billomat", value: "billomatId"},
      {text: "WooCommerce", value: "woocommerceId"},
      {
        text: "Aktionen", value: "edit",
        sortable: false,
      },
    ]
  }),
  props: {
    movement: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    breadCrumbs() {
      if (this.selectedCompany === null) {
        return [{
          text: "Firmen", disabled: true
        }]
      } else {
        let result = [{
          text: "Firmen", disabled: false, link: true
        }]

        if (this.detail !== null) {
          result.push({text: this.selectedCompany.name, disabled: false, link: true})
          result.push({text: this.detail.course.title, disabled: true, link: false})
        } else {
          result.push({text: this.selectedCompany.name, disabled: true, link: true})
        }
        return result;
      }
    }
  },
  methods: {
    startMovement(company) {
      this.$emit("move", company)
    },
    endMovement() {
      this.$emit("cancel")
    },
    createMember(company) {
      this.userEditCompanyId = company.id;
      this.userCreationDialog = true;
    },
    onUserCreated() {
      this.userCreationDialog = false;
      this.userEditCompanyId = null;
    },
    createCompany() {
      this.selectedCompany = new Company()
    },
    deleteCompany(company) {
      this.companyForDeletion = company;
      this.askDeleteCompany = true;
    },
    finallyDeleteCompany() {
      this.$httpCompanyApi.delete(this.companyForDeletion.id, () => {
        this.askDeleteCompany = false;
        this.success = true;
        setTimeout(() => this.success = false, 3000);
        this.loadData();
      }, () => {
        this.error = true;
        setTimeout(() => this.error = false, 3000);
      });
    },
    onCompanyCreated() {
      this.selectedCompany = null;
      this.loadData();
    },
    detailSet(licence) {
      this.detail = licence;
    },
    openLink(id) {
      window.open("https://www.behrendtonline.com/wp-admin/user-edit.php?user_id=" + id);
    },
    clickBreadCrumb(text) {
      if (this.selectedCompany && text === "Firmen") {
        this.selectedCompany = null;
        this.detail = null;
        this.loadData();
      } else if (this.detail !== null) {
        this.detail = null;
      }
    },
    openEdit(item) {
      this.tab = 0;
      this.selectedCompany = item;
    },
    openCourses(item) {
      this.tab = 1;
      this.selectedCompany = item;
    },
    openMembers(item) {
      this.tab = 2;
      this.selectedCompany = item;
    },
    loadData() {
      this.$httpCompanyApi.getAll((result) => {
        this.companies = result;
      })
    },
    triggerLoadCompanyUsersWithInactiveChange() {
      this.loadInActiveMembers = !this.loadInActiveMembers;
      this.loadCompanyUsers();
    },
    loadCompanyUsers() {
      this.loading = true;
      this.$httpUserApi.companyUsersForCompany(this.loadInActiveMembers, this.selectedCompany.id, (result) => {
        this.members = result;
        this.loading = false;
      })
    }
  },

  mounted() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
